import { ReactNode } from "react";

export interface BottomSectionContainerProps {
    children: ReactNode;
}

export const BottomSectionContainer = ({ children }: BottomSectionContainerProps) => {
    return <div className={`px-2 py-2 border-t border-t-irGray-300 dark:border-t-darkSurface-600 dark:bg-darkSurface-100`}>{children}</div>;
};
